import React, { useEffect } from "react";
import { fetchPAGWithFilters } from "../../store/reducers/dashboardSlice/api";
import {
  gridColumns_PortfolioAtGlanceNewTab,
  gridColumns_PortfolioAtGlanceNewTabBroker,
} from "../../Utils/TableColumnDefs";
import CommonGrid from "../CommonGrid";

import { useDispatch, useSelector } from "react-redux";
import { roleType } from "../../Utils/constant";
import { useLocation } from "react-router-dom";
const portfolioFilter = [
  { name: "Principal Amount", key: "principal", type: "range" },
  { name: "Next Due Date", key: "next_due_date", type: "date" },
  { name: "Next Due Date", key: "next_due_date", type: "month" },
];

const PAGTWithFilters = ({ className = "" }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const data = useSelector((state) => state.dashboard?.["pAGWithFilter"]?.data);
  const status = useSelector(
    (state) => state.dashboard?.["pAGWithFilter"]?.status
    );
    const lenderId = useSelector((state) => state.account.lenderId);
    const valuesToPopulate = location?.state;
  // const valuesToPopulate = useSelector((state) => state.dashboard.pieSelected);

  useEffect(() => {
    dispatch(
      fetchPAGWithFilters({
        lenderId: lenderId,
        extraparm: valuesToPopulate,
        role: selectedRole,
      })
    );
  }, [dispatch, lenderId, valuesToPopulate, selectedRole]);

  return (
    <CommonGrid
      status={status}
      className={`portfolio-at-glance col-sm-6 ${className}`}
      title={""}
      gridColumns={
        selectedRole === roleType.broker
          ? gridColumns_PortfolioAtGlanceNewTabBroker
          : gridColumns_PortfolioAtGlanceNewTab
      }
      columnData={data}
      filterOption={portfolioFilter}
      tableTotal={["principal"]}
    />
  );
};

export default PAGTWithFilters;
